class FixedRate {
    indicative;
    value;
    constructor(response) {
        this.indicative = response.indicative;
        this.value = response.value;
    }
    print() {
        if (this.value !== undefined) {
            if (this.indicative === true) {
                return { value: this.value, suffix: " (indic.)" };
            }
            return { value: this.value };
        }
        return undefined;
    }
}
export default FixedRate;
